import * as swcHelpers from '@swc/helpers';
import { initialize } from '@bloomreach/spa-sdk';
import { createBloomreachApiUrl } from '../utils/create-api-url.js';
import { createPath } from '../utils/create-path.js';
import { brHttpClient } from '../utils/http-client.js';

function getPageModel(apiUrl, path, opts) {
    return _getPageModel.apply(this, arguments);
}
function _getPageModel() {
    _getPageModel = swcHelpers.asyncToGenerator(function*(apiUrl, path, opts) {
        const { headers ={} , connection , visitor , locale , isMultilingual  } = opts;
        if (!apiUrl) {
            throw new Error(`Need a valid Bloomreach api url to fetch a pageModel! Got apiUrl: ${apiUrl}`);
        }
        if (!path) {
            throw new Error(`Need a valid path to fetch a pageModel! Got path: ${path}`);
        }
        if (isMultilingual && !locale) {
            throw new Error(`Need a valid locale when isMultilingual is set to true! Got locale: ${locale}`);
        }
        const cmsBaseUrl = createBloomreachApiUrl(apiUrl, isMultilingual ? locale : undefined);
        const parsedPath = createPath(path, isMultilingual ? locale : undefined);
        const request = {
            connection,
            path: parsedPath,
            headers: swcHelpers.objectSpread({}, headers['x-forwarded-for'] ? {
                'x-forwarded-for': headers['x-forwarded-for']
            } : {})
        };
        const { origin  } = new URL(apiUrl);
        const configuration = {
            cmsBaseUrl,
            visitor,
            request,
            httpClient: brHttpClient,
            origin: origin.replace('www', 'cms')
        };
        if (process.env.NODE_ENV !== 'production') {
            console.log(`Fetching: ${cmsBaseUrl}/resourceapi${parsedPath}`);
        }
        return initialize(configuration);
    });
    return _getPageModel.apply(this, arguments);
}

export { getPageModel };
//# sourceMappingURL=get-page-model.js.map
